import classNames from 'classnames';
import Image, { ImageProps } from 'components/gruenland/atoms/image';
import Link from 'components/gruenland/atoms/link';
import { TYPOGRAPHY_MODULE_TITLE } from 'lib/typography';
import { Reference } from 'types/reference';

export type Module03TileProps = {
  title?: string;
  description?: string;
  image?: ImageProps;
  imageLg?: ImageProps;
  ctaLabel?: string;
  ctaLink?: Reference;
};

const Module03Tile: React.FC<Module03TileProps> = ({ title, description, image, imageLg, ctaLink, ctaLabel }) => {
  return (
    <div>
      {image?.media?.resourceType === 'image' && (
        <div
          className={classNames('relative', {
            'lg:hidden': imageLg?.media,
          })}
        >
          <Image {...image} alt={image.alt} />
        </div>
      )}
      {imageLg?.media && (
        <div className="relative hidden lg:block">
          <Image {...imageLg} alt={imageLg.alt} fill />
        </div>
      )}
      {ctaLabel && (
        <div className="px-10 pt-10">
          <h2 className={classNames(TYPOGRAPHY_MODULE_TITLE, 'mb-5')}>{title}</h2>
          <p className="mb-5">{description}</p>
          <Link link={ctaLink} variant="buttonSecondary">
            {ctaLabel}
          </Link>
        </div>
      )}
    </div>
  );
};

export default Module03Tile;
